// src/constants/afsWorkflow.js
// Phase 5 (Issue A) — single source of truth for mapping a saved
// afs_jobs.workflow_stage back to (a) the page a resuming preparer needs to
// land on, and (b) a human-readable label. Used by both Dashboard.jsx and
// AFSHistory.jsx — kept in one file rather than copied into each, since a
// future new stage added in one place and not the other would silently
// break Resume for whichever page didn't get updated.

// Bank-statement draft-autosave fix: the bank-statement pipeline previously
// had no draft persistence at all, so it never needed an entry here. It now
// autosaves continuously from upload onward — see BankStatement.jsx and
// BankStatementBalanceSheet.jsx — using these two additional stages.
export const STAGE_TO_ROUTE = {
  trial_balance:                '/trial-balance',
  documents:                    '/additional-documents',
  notes:                        '/notes',
  review:                       '/review',
  bank_statement:               '/bank-statement',
  bank_statement_balance_sheet: '/bank-statement/balance-sheet',
}

export const STAGE_LABEL = {
  trial_balance:                'Trial Balance',
  documents:                    'Additional Documents',
  notes:                        'Notes',
  review:                       'Review',
  complete:                     'Complete',
  bank_statement:               'Bank Statement',
  bank_statement_balance_sheet: 'Bank Statement — Balance Sheet',
}
